export default "__VITE_ASSET__DCZ9Y2$i__"